import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { validator } from '@ally/validator';
import { DATE_PICKER_FORMAT } from '../../../../constants';
dayjs.extend(customParseFormat);
var IsValidDate = function (date) {
    return dayjs(date, DATE_PICKER_FORMAT, true).isValid();
};
export var IsValidDateErrorMessage = 'Please enter a valid date.';
export var IsValidDateValidator = validator(IsValidDate, IsValidDateErrorMessage);
//# sourceMappingURL=IsValidDate.js.map